var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900.31,
    height: 787,
    viewBox: "0 0 900.31 787",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-510.055 -146.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 52,
    height: 27,
    transform: "translate(1272.055 430.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 52,
    height: 27,
    transform: "translate(1234.055 233.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 52,
    height: 27,
    transform: "translate(1271.055 264.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 52,
    height: 27,
    transform: "translate(1171.055 235.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 52,
    height: 27,
    transform: "translate(510.055 525.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 52,
    height: 27,
    transform: "translate(1275.055 297.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 52,
    height: 27,
    transform: "translate(1208.055 266.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 52,
    height: 27,
    transform: "translate(1335.055 503.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 52,
    height: 27,
    transform: "translate(1272.055 505.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 52,
    height: 27,
    transform: "translate(510.055 430.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 52,
    height: 27,
    transform: "translate(547.055 461.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 52,
    height: 27,
    transform: "translate(828.055 146.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 52,
    height: 27,
    transform: "translate(1238.055 644.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 52,
    height: 27,
    transform: "translate(551.055 494.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 52,
    height: 27,
    transform: "translate(865.055 177.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 52,
    height: 27,
    transform: "translate(675.055 360.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 52,
    height: 27,
    transform: "translate(712.055 391.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 52,
    height: 27,
    transform: "translate(811.055 374.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 52,
    height: 27,
    transform: "translate(716.055 424.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 52,
    height: 27,
    transform: "translate(1308.055 644.5)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72-1818",
    "data-name": "Path 72",
    d: "M503.71,57.57h0a75.57,75.57,0,0,1,75.57,75.57v32.24H428.14V133.14a75.57,75.57,0,0,1,75.57-75.57Z",
    transform: "translate(509.425 146.5)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 86.14,
    cy: 59.19,
    rx: 86.14,
    ry: 59.19,
    transform: "translate(927.525 263.26)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-1819",
    "data-name": "Path 73",
    d: "M598.44,289.79s18,94.07,0,119.44,55,35.41,55,35.41L729,417.16l10.57-67.65s-46-25.9-36.47-78.22Z",
    transform: "translate(360.005 90)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74-1820",
    "data-name": "Path 74",
    d: "M821.46,606.89s4.76,20.61-21.14,24.31a146.452,146.452,0,0,1-46.08-.55l-5.71-51.77h60.25Z",
    transform: "translate(360.005 90)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75-1821",
    "data-name": "Path 75",
    d: "M364.12,580.51S352.68,627,378.58,631.2s121,4.23,121,4.23v-55l-43.06,9.2L416.1,550.87Z",
    transform: "translate(360.005 90)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76-1822",
    "data-name": "Path 76",
    d: "M604,320.18l-101.21,21.4s-38.58,1.59-63.42,52.85-78.75,197.66-78.75,197.66,46-46.51,99.89,3.17l35.94-65-7.93,103.06H767V584.69s58.13,31.18,53.91,48.62c0,0,49.75-128.18,39-186.43a396.174,396.174,0,0,1-5.94-54.5h0a73,73,0,0,0-51.38-66.67c-5.24-1.61-11-3.12-17.4-4.47-59.72-12.68-75,0-75,0s-11.57,37.64-11.36,54.7c.26,21.93-31.18,36.47-31.18,36.47s-46.51-11.1-48.62-20.08S600.28,330.75,604,320.18Z",
    transform: "translate(360.005 90)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77-1823",
    "data-name": "Path 77",
    d: "M604,318.07l-101.21,21.4s-38.58,1.59-63.42,52.85S360.61,590,360.61,590s46-46.51,99.89,3.17l35.94-65L488.51,631.2H767V582.58s58.13,31.18,53.91,48.62c0,0,49.75-128.18,39-186.43a396.194,396.194,0,0,1-5.94-54.5h0a73,73,0,0,0-51.38-66.67c-5.24-1.61-11-3.12-17.4-4.47-59.72-12.68-75,0-75,0s-11.57,37.64-11.36,54.7c.26,21.93-31.18,36.47-31.18,36.47s-46.51-11.1-48.62-20.08S600.28,328.64,604,318.07Z",
    transform: "translate(360.005 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78-1824",
    "data-name": "Path 78",
    d: "M707.42,313.58a71.53,71.53,0,0,1-2.76-37.52L600,294.55s1.51,7.91,3.22,19.76a71.86,71.86,0,0,0,104.18-.73Z",
    transform: "translate(360.005 90)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79-1825",
    "data-name": "Path 79",
    d: "M725.27,259.67a71.875,71.875,0,1,1-143.74,1.74c.01-.58.01-1.16.01-1.74a71.856,71.856,0,0,1,83.93-70.87h0a71.82,71.82,0,0,1,59.61,66.1Q725.27,257.27,725.27,259.67Z",
    transform: "translate(360.005 90)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82-1826",
    "data-name": "Path 82",
    d: "M628.36,192.3l.1-.06a71.816,71.816,0,0,0-46.93,67.43q0,.87,0,1.74a16,16,0,0,0,6.45-1.55c17.52-8.18,28-33.2,32.16-50.65C621.64,203,623.05,195.93,628.36,192.3Z",
    transform: "translate(360.005 90)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83-1827",
    "data-name": "Path 83",
    d: "M683.37,194.32a71.279,71.279,0,0,0-17.87-5.51,23.06,23.06,0,0,1,12.83,8.06,32.859,32.859,0,0,1,3.93,7,72.07,72.07,0,0,0-60.45,1.25c4.51,9.89,18.5,15.28,27.84,18.89q15.34,5.92,31,10.83l-9.24-7.5,20.87,3.32a36.153,36.153,0,0,0-1.46-12.3c4,3.22,9.3,4.3,13.64,7,8.13,5.13,11.52,15,15.95,23.55,1.17,2.26,2.55,4.57,4.66,6a71.91,71.91,0,0,0-41.7-60.59Z",
    transform: "translate(360.005 90)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85-1828",
    "data-name": "Path 85",
    d: "M573.33,246.19s74-92,159.61,0l-7.4-20.61s-40.17-58.66-68.7-46-56.55,21.67-56.55,21.67Z",
    transform: "translate(360.005 90)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86-1829",
    "data-name": "Path 86",
    d: "M512.55,444.38s-15.85,42.28,6.34,80.33-19.55,53.91-19.55,53.91",
    transform: "translate(360.005 90)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87-1830",
    "data-name": "Path 87",
    d: "M769.4,406.33s27.48,34.88,9.51,66.06S762,578.62,762,578.62",
    transform: "translate(360.005 90)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88-1831",
    "data-name": "Path 88",
    d: "M338.82,553.3H644.29a25.37,25.37,0,0,1,25.37,25.37H313.46A25.37,25.37,0,0,1,338.82,553.3Z",
    transform: "translate(509.425 146.5)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89-1832",
    "data-name": "Path 89",
    d: "M369.9,378.89H613.22a39,39,0,0,1,39,39V559.11H330.9V417.89A39,39,0,0,1,369.9,378.89Z",
    transform: "translate(509.425 146.5)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 19.03,
    cy: 19.03,
    r: 19.03,
    transform: "translate(981.685 604.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90-1833",
    "data-name": "Path 90",
    d: "M577.56,204.7s72.72-72.68,151.15-1.33",
    transform: "translate(360.005 90)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 7.3,
    height: 41.39,
    transform: "translate(1099.785 290.07)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91-1834",
    "data-name": "Path 91",
    d: "M580.62,170.35h0a25.16,25.16,0,0,1,25.16,25.16v1.62a25.16,25.16,0,0,1-25.16,25.16h0Z",
    transform: "translate(509.425 146.5)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 11.36,
    height: 56.81,
    rx: 5.68,
    transform: "translate(1085.175 314.42)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 7.3,
    height: 41.39,
    transform: "translate(925.745 332.27) rotate(180)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92-1835",
    "data-name": "Path 92",
    d: "M550.32,227.66h0a25.16,25.16,0,0,1,25.16,25.16v1.62a25.16,25.16,0,0,1-25.16,25.16h0Z",
    transform: "translate(1485.805 597.26) rotate(180)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 11.36,
    height: 56.81,
    rx: 5.68,
    transform: "translate(940.355 372.03) rotate(180)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-1836",
    "data-name": "Path 93",
    d: "M738.92,155.83c-9.89-20.56-31.43-45.42-77.86-47.41v-.06h-.56l-16.45.78v.08c-46.12,2.12-67.56,26.89-77.42,47.38A106.59,106.59,0,0,0,556.41,201l5.68-.14,5.68-.13A96.651,96.651,0,0,1,577,161.21c12.52-25.72,35.56-39.39,68.47-40.66h0l14.55-.81h0C692.95,121,716,134.69,728.51,160.4a96.652,96.652,0,0,1,9.25,39.54l5.68.13,5.68.14a106.59,106.59,0,0,0-10.2-44.38Z",
    transform: "translate(360.005 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 774.71,
    height: 208,
    transform: "translate(583.705 725.5)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 774.71,
    height: 22,
    transform: "translate(583.705 739.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 878.63,
    height: 27,
    transform: "translate(531.735 722.5)",
    fill: "#d6d6e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero1);
export default __webpack_public_path__ + "static/media/hero-1.266ec6809c999c668cde30b7c4ba172e.svg";
export { ForwardRef as ReactComponent };